import React, { useMemo } from 'react'

import { Logo001Svg, Logo002Svg, Logo003Svg } from 'Assets/Svg'

import { Container, ContainerProps } from './styles'

type Props = ContainerProps & {
  secondary?: boolean
  width?: number
  tertiary?: boolean
}

function Logo({ isClickable, secondary, tertiary, width = 108 }: Props) {
  const logo = useMemo(() => {
    if (secondary) return Logo002Svg()

    if (tertiary) return Logo003Svg()

    return Logo001Svg()
  }, [secondary, tertiary])

  return (
    <Container isClickable={isClickable} width={width}>
      {logo}
    </Container>
  )
}

export default Logo
